var logs = {};

function request(reflexId, target, args, stimulusControllerIdentifier, element) {
  logs[reflexId] = new Date();
  console.log("\u2B95 ".concat(target), {
    reflexId: reflexId,
    args: args,
    stimulusControllerIdentifier: stimulusControllerIdentifier,
    element: element
  });
}

function success(response) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    halted: false
  };
  var html = {};
  var payloads = {};
  var elements = {};
  var event = response.event,
      events = response.events;

  var _ref = event.detail.stimulusReflex || {},
      reflexId = _ref.reflexId,
      target = _ref.target,
      last = _ref.last;

  if (events) {
    Object.keys(events).map(function (selector) {
      elements[selector] = events[selector].detail.element;
      html[selector] = events[selector].detail.html;
      payloads[selector] = events[selector].detail.stimulusReflex;
    });
  }

  console.log("\u2B05 ".concat(target), {
    reflexId: reflexId,
    duration: "".concat(new Date() - logs[reflexId], "ms"),
    halted: options.halted,
    elements: elements,
    payloads: payloads,
    html: html
  });
  if (last) delete logs[reflexId];
}

function error(response) {
  var _ref2 = response || {},
      event = _ref2.event,
      element = _ref2.element;

  var _ref3 = event || {},
      detail = _ref3.detail;

  var _ref4 = detail.stimulusReflex || {},
      reflexId = _ref4.reflexId,
      target = _ref4.target,
      error = _ref4.error;

  console.error("\u2B05 ".concat(target), {
    reflexId: reflexId,
    duration: "".concat(new Date() - logs[reflexId], "ms"),
    error: error,
    payload: event.detail.stimulusReflex,
    element: element
  });
  delete logs[reflexId];
}

export default {
  request: request,
  success: success,
  error: error
};